import React from 'react';
import { useHistory } from 'react-router-dom';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';

const AuthAppSuccess = () => {
  const history = useHistory();
  return (
    <div className="rightside-container">
      <div className="rightside-body px-6">
        <div className='flex flex-column align-items-center'>
          <h3>Two-step Verification</h3>
          <span>Two-step verification adds an additional layer of security by using a second device to verify your identity.</span>
          <Divider className='py-3' />
        </div>
        <div className="pt-2 lg:w-5 md:w-5 mx-auto">
          <div style={{ width: '150px', height: '150px'}} className="bg-green-500 p-2 border-circle flex justify-content-center align-items-center mx-auto">
            <i className="pi pi-check text-white" style={{ 'fontSize': '3em' }} />
          </div>
          <h2 className='text-center'>Success!</h2>
          <p className='mt-5'>bo.chen@gmail.com has been verified and can receive verification codes.</p>
          <b>Would you like to set this as the default verification method?</b>
          <Button label="Set as default" className="p-button-info w-full mt-3 py-3" />
          <Button onClick={() => history.push("/auth/multi-factor-auth")} label="Close" className="p-button-info p-button-text w-full mt-2 py-3" />
        </div>
      </div>
    </div>
  )
}

export default AuthAppSuccess;
